import type {
  ModuleId,
  SearchEntity,
  SearchEntityDestination,
  SearchModule,
} from "./search-modules";

export type SearchResultKind =
  | "module"
  | "moduleOpen"
  | "entity"
  | "frequentEntity"
  | "destination"
  | "recentModule"
  | "recentEntity"
  | "hint"
  | "action"
  | "page";

type SearchResultBase = {
  id: string;
  value: string;
  label: string;
  description?: string;
  disabled?: boolean;
  className?: string;
};

export type ModuleResultItem = SearchResultBase & {
  kind: "module";
  module: SearchModule;
};

export type ModuleOpenResultItem = SearchResultBase & {
  kind: "moduleOpen";
  module: SearchModule;
};

export type EntityResultItem = SearchResultBase & {
  kind: "entity";
  module: SearchModule;
  entity: SearchEntity;
};

export type FrequentEntityResultItem = SearchResultBase & {
  kind: "frequentEntity";
  module: SearchModule;
  entity: SearchEntity;
};

export type DestinationResultItem = SearchResultBase & {
  kind: "destination";
  module: SearchModule;
  entity: SearchEntity;
  destination: SearchEntityDestination;
};

export type RecentModuleResultItem = SearchResultBase & {
  kind: "recentModule";
  module: SearchModule;
  href: string;
};

export type RecentEntityResultItem = SearchResultBase & {
  kind: "recentEntity";
  module: SearchModule;
  entity: SearchEntity;
};

export type HintResultItem = SearchResultBase & {
  kind: "hint";
  disabled: true;
};

export type ActionResultItem = SearchResultBase & {
  kind: "action";
  actionId: string;
};

export type PageResultItem = SearchResultBase & {
  kind: "page";
  moduleId: ModuleId;
  href: string;
};

export type SearchResultItem =
  | ModuleResultItem
  | ModuleOpenResultItem
  | EntityResultItem
  | FrequentEntityResultItem
  | DestinationResultItem
  | RecentModuleResultItem
  | RecentEntityResultItem
  | HintResultItem
  | ActionResultItem
  | PageResultItem;

export type SearchResultGroup = {
  id: string;
  heading: string;
  items: SearchResultItem[];
  priority?: number;
};

export function isHintResultItem(item: SearchResultItem): item is HintResultItem {
  return item.kind === "hint";
}

export function isEntityLikeResultItem(
  item: SearchResultItem,
): item is EntityResultItem | FrequentEntityResultItem | RecentEntityResultItem {
  return (
    item.kind === "entity" ||
    item.kind === "frequentEntity" ||
    item.kind === "recentEntity"
  );
}

export function isModuleLikeResultItem(
  item: SearchResultItem,
): item is ModuleResultItem | ModuleOpenResultItem | RecentModuleResultItem {
  return (
    item.kind === "module" || item.kind === "moduleOpen" || item.kind === "recentModule"
  );
}
